import React from 'react'
import './styles.scss'
export const BarChart = ({
  data,
  title,
  sub,
  highlighted = [],
  source,
  max,
  children
}: {
  data?: { n: string; v: number }[]
  title?: string
  sub?: string
  highlighted?: string[]
  source?: React.ReactChild
  max?: number
  children?: React.ReactChild
}) => {
  return (
    <div className='BarChart'>
      <div className='title'>{title}</div>
      <div className='sub'>{sub}</div>
      <div className='bars'>
        {children && children}
        {data &&
          data.map(m => {
            return (
              <div
                className={
                  'barwrapper ' +
                  (highlighted.indexOf(m.n) !== -1 ? 'highlight' : '')
                }
              >
                <div className='label'>{m.n}</div>
                <div className='bar'>
                  <div
                    className='inner'
                    style={{ flex: '0 0 ' + (m.v * 100) / max + '%' }}
                  />{' '}
                  <div className='value'>{m.v}</div>
                </div>
              </div>
            )
          })}
      </div>
      <div className='source'>Quelle: {source}</div>
    </div>
  )
}
